import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { AxwayAuthenticationService } from '@ptl/xhr';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class LogoutComponent extends GlobalShadowStyleDirective implements OnInit {

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private  axwayAuthService: AxwayAuthenticationService
    ) { 
      super();
    }

  ngOnInit() {
  }

  trigger() {
    this.axwayAuthService.cleanupAfterLogoutOrExpiration();
  }
}
